import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainingComponent } from './training/training.component';
import { ControlsModule } from '../controls/controls.module';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';

import * as fromTraining from './training.reducer';
import { StoreModule } from '@ngrx/store';
import { CanvasModule } from '../canvas/canvas.module';
import { KVideoModule } from '../k-video/k-video.module';
import { BrowserModule } from '@angular/platform-browser';
import { CareComponent } from './care/care.component';
import { OverviewComponent } from './care/overview/overview.component';
import { SegmentsComponent } from './care/segments/segments.component';
import { SketchesComponent } from './care/sketches/sketches.component';
import { SelTaskComponent } from './sel-task/sel-task.component';

import { PatientComponent } from './patient/patient.component';
import { NewUserComponent } from './new-user/new-user.component';
import { SelUserComponent } from './sel-user/sel-user.component';
import { SelPatientComponent } from './sel-patient/sel-patient.component';

@NgModule({
  declarations: [
    TrainingComponent,
    CareComponent,
    OverviewComponent,
    SegmentsComponent,
    SketchesComponent,
    SelTaskComponent,
    NewUserComponent,
    PatientComponent,
    SelUserComponent,
    SelPatientComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ControlsModule,
    FileUploadModule,
    StoreModule.forFeature('ktraining', fromTraining.trainingReducer),
    CanvasModule,
    KVideoModule,

  ], exports: [
    TrainingComponent,
  ]
})
export class TrainingModule { }
